import axios from '../../../app/common/libs/http';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const fetchAgents = createAsyncThunk(
  'team-activity/agents',
  async (data) =>
    await axios.post(
      `${process.env.REACT_APP_APIURL}/user/getFlecxAgents`,
      data
    )
);
export const fetchAgentsStats = createAsyncThunk(
  'team-activity/agentsStats',
  async (data) =>
    await axios.post(
      `${process.env.REACT_APP_APIURL}/insights/agentActivities`,
      data
    )
);
export const forceAwayAgent = createAsyncThunk(
  'team-activity/forceAwayAgent',
  async (userId) =>
    await axios.post(
      `${process.env.REACT_APP_APIURL}/user/forceAwayAgent/${userId}`,
      { userId: userId }
    )
);
export const fetchAgentsWithStats = createAsyncThunk(
  'team-activity/agentsWithStats',
  async (data) =>
    await Promise.all([
      axios.post(`${process.env.REACT_APP_APIURL}/user/getFlecxAgents`, data),
      axios.post(
        `${process.env.REACT_APP_APIURL}/insights/agentActivities`,
        data
      ),
    ])
);
